import {PanelInteractContextProvider} from '@wandb/weave/components/Panel2/PanelInteractContext';
import {PanelRootContextProvider} from '@wandb/weave/components/Panel2/PanelPanel';
import {PanelRenderedConfigContextProvider} from '@wandb/weave/components/Panel2/PanelRenderedConfigContext';
import React from 'react';

export const Weave1PanelContextProvider = React.memo(({children}) => {
  return (
    <PanelRootContextProvider>
      <PanelRenderedConfigContextProvider>
        <PanelInteractContextProvider>{children}</PanelInteractContextProvider>
      </PanelRenderedConfigContextProvider>
    </PanelRootContextProvider>
  );
});
Weave1PanelContextProvider.displayName = 'Weave1PanelContextProvider';
